import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { periods } from '@/constants/reports';

dayjs.extend(customParseFormat);

const JANUARY = 1;
const DECEMBER = 12;

/*
    ! Временное решение.
    Так как пока не понятно, как определять ВЕСЬ период, указывается широкий диапазон дат (года)
    Соответствует типу periods.ALL - за ВЕСЬ срок
*/
const LOWER_LIMIT = 988;
const UPPER_LIMIT = 3000;

const adapter = lib => ({
    getMonth(date) {
        return lib(date).month() + 1;
    },
    getYear(date) {
        return lib(date).year();
    },
});

const time = adapter(dayjs);

/*
    Описание:
        * MonthBegin - Числа от 1 до 12 по номеру месяца
        * YearBegin - Любые целые числа
        * MonthEnd - Числа от 1 до 12 по номеру месяца
        * YearEnd - Числа от 1 до 12 по номеру месяца

    Для месяца:
        В поля MonthEnd и YearEnd копируем значения полей MonthBegin и YearBegin

    Для года:
        В поле YearEnd копируем значения поля YearBegin
        MonthBegin выставляется в январь (1), MonthEnd - в декабрь (12)

    Для периода:
        Заполняем все поля согласно выбранному значению
*/

const timeToFields = (startMonth, startYear, endMonth, endYear) => ({
    MonthBegin: startMonth,
    YearBegin: startYear,
    MonthEnd: endMonth || startMonth,
    YearEnd: endYear || startYear,
});

export const formatDateParams = (type, date) => {
    /*
        Существует простая проверка на пустоту поля date (его нельзя оставлять пустым).
        Перестраховка.

        Если type == periods.ALL, то дата может быть пустой, так как она проставляется этой функцией
    */
    if (!date && type !== periods.ALL) return {};

    if (type === periods.MONTH) {
        const month = time.getMonth(date);
        const year = time.getYear(date);

        return timeToFields(month, year);
    }

    if (type === periods.YEAR) {
        const year = time.getYear(date);

        return timeToFields(JANUARY, year, DECEMBER);
    }

    if (type === periods.PERIOD) {
        const start = Array.isArray(date) ? date[0] : date.startDate;
        const end = Array.isArray(date) ? date[1] : date.endDate;

        return timeToFields(time.getMonth(start), time.getYear(start), time.getMonth(end), time.getYear(end));
    }

    /*
        Период с даты. В некоторых реализациях дата для всего периода может быть известна.
        TODO: сейчас под gosplan подстраивается. Переписать.
    */
    if (type === periods.ALL && date) {
        return timeToFields(
            time.getMonth(date.startDate),
            time.getYear(date.startDate),
            time.getMonth(date.endDate),
            time.getYear(date.endDate)
        );
    }

    /*
        Период без даты. Т.е. дата проставляется текущей конфигурацией
    */
    if (type === periods.ALL) {
        return timeToFields(JANUARY, LOWER_LIMIT, DECEMBER, UPPER_LIMIT);
    }

    /*
        * Заглушка.
        Если придет тип, который не обрабатывается в условиях, все поля отвечающие за диапазон дат
        не будет участвовать в выборке.
    */
    return {};
};

/*
    Эта функция работает с датой (месяц и год), которая необходима для отчетов - ФОНД СКВАЖИН.
    Имеет на выходе свои поля, поэтому функцию выше нет возможности использовать.
*/
export const formatFundDate = (month, year) => {
    if (month && year) {
        return {
            Month: month,
            Year: typeof year === 'string' ? dayjs(year).year() : year,
        };
    }
    return {};
};

export const formattedDate = date => {
    if (date?.startDate && date?.endDate) {
        return {
            startDate: dayjs(date.startDate),
            endDate: dayjs(date.endDate),
        };
    }
    return date ? dayjs(date) : undefined;
};
